module.exports = __webpack_public_path__ + "static/media/logo-fr.01f6715b.png";